export function changeName(name) {
    return (dispatch) => {
        if (name.trim().length > 2) {
            dispatch({ type: 'VALIDATE_WIDGET_NAME', error: null });
        }
        dispatch({
            type: 'WIDGET_CHANGE_NAME',
            name: name,
        });
    };
}
export function changeQueue(queueId) {
    return (dispatch) => {
        if (queueId !== null && queueId !== 'null') {
            dispatch({ type: 'VALIDATE_WIDGET_QUEUE', error: null });
        }
        dispatch({
            type: 'WIDGET_CHANGE_QUEUE',
            queueId: queueId,
        });
    };
}
export function addNewWidget() {
    return (dispatch) => dispatch({ type: 'CHAT_ADD_NEW_WIDGET' });
}
export function hideChatWidgetModal() {
    return (dispatch) => dispatch({ type: 'CHAT_HIDE_CHAT_WIDGET_MODAL' });
}
export function showDeleteWidgetModal(widget) {
    return (dispatch) => dispatch({
        type: 'CHAT_SHOW_DELETE_WIDGET_MODAL',
        widget: widget,
    });
}
export function hideDeleteWidgetModal() {
    return (dispatch) => dispatch({ type: 'CHAT_HIDE_DELETE_WIDGET_MODAL' });
}
export function createWidget(widget) {
    if (widget.name.trim().length <= 2) {
        return (dispatch) => {
            dispatch({
                type: 'VALIDATE_WIDGET_NAME',
                error: 'Please add a name',
            });
        };
    }
    if (widget.queue_id === undefined ||
        widget.queue_id === null ||
        widget.queue_id === '' ||
        widget.queue_id === 'null') {
        return (dispatch) => {
            dispatch({
                type: 'VALIDATE_WIDGET_QUEUE',
                error: 'Please select a queue',
            });
        };
    }
    return (dispatch) => {
        dispatch({
            type: 'CHAT_CREATE_WIDGET',
            widget: widget,
        });
    };
}
export function validateWidgetName(name) {
    return (dispatch) => {
        dispatch({
            type: 'VALIDATE_WIDGET_NAME',
            error: 'Please add a name',
        });
    };
}
export function readWidgets(payload) {
    return (dispatch) => {
        dispatch({
            type: 'CHAT_READ_WIDGETS',
            payload: payload,
        });
    };
}
export function readWidget(widgetId) {
    return (dispatch) => {
        dispatch({
            type: 'CHAT_READ_WIDGET',
            widgetId: widgetId,
        });
    };
}
/**
 * Builds the data object for the update of a widget.
 *
 * @param {ChatWidget} widget A widget object.
 * @returns {object} Dispatch type "CHAT_UPDATE_WIDGET", data object.
 */
export function updateWidget(widget) {
    if (widget.id === undefined || widget.id === null) {
        console.warn('actions creator updateWidget(widget) no id given. Given widget.id = ', widget.id);
        return undefined;
    }
    const data = {
        updates: {},
    };
    if (widget.name !== undefined) {
        data.updates.name = widget.name;
    }
    if (widget.agent_name_template !== undefined) {
        data.updates.agent_name_template = widget.agent_name_template;
    }
    return (dispatch) => {
        dispatch({
            type: 'CHAT_UPDATE_WIDGET',
            data: data,
            id: widget.id,
        });
    };
}
export function deleteWidget(index, widget) {
    return (dispatch) => {
        dispatch({
            type: 'CHAT_DELETE_WIDGET',
            widget: widget,
            index: index,
        });
    };
}
